<div class="label row">{{ title }}</div>
<div class="row">
  <!-- US city with full geo -->
  @if (render === 'us-geo') {
    <div>
      <input [ngModel]="usGeoString" class="restrictNormal geoInput location" disabled id="LocationInputUS" />
    </div>
  }

  <!-- Outside of US with full geo -->
  @if (render === 'foreign-geo') {
    <div>
      <input
        [ngModel]="foreignGeoString"
        class="restrictNormal geoInput location"
        disabled
        id="LocationInputForeign"
        />
    </div>
  }

  <!-- outside of US with minimal geo -->
  @if (render === 'basic-geo') {
    <div>
      <input [ngModel]="basicGeoString" class="restrictNormal geoInput location" disabled id="LocationInputBasic" />
    </div>
  }

  <!-- no geo and not AWS region -->
  @if (render === 'region') {
    <div>
      <input [ngModel]="region" class="restrictNormal location" disabled id="LocationInputRegion" />
    </div>
  }

  <!-- no geo and AWS region -->
  @if (render === 'data-center') {
    <div>
      <input [ngModel]="dataCenter" class="restrictNormal location" disabled id="LocationInputDC" />
    </div>
  }
</div>
